import React from 'react'

const HowPlay = () => {
  return (
    <div>
       <h1>This is howplay</h1>
    </div>
  )
}

export default HowPlay
